{
  "headings": {
    "preview": "Preview the fault report",
    "defectNotice": "Report a fault",
    "defectNoticeEdit": "Edit a fault report",
    "success": "Fault report",
    "editNotice": "Fault report"
  },
  "texts": {
    "instructions": "Report a non-urgent fault in your apartment or the common areas. If the matter is urgent – for example, water damage – please call the maintenance company.",
    "list": {
      "title": "Your fault report",
      "workOrder": "Order attached to the fault report",
      "status": {
        "completed": "Marked as processed",
        "created": "Created"
      }
    },
    "eventsTitle": "Follow the progress",
    "notEditable": "This report can no longer be edited.",
    "notTrackable": "This report has been moved to another location. It can no longer be edited and its progress cannot be followed."
  },
  "placeholders": {
    "title": "Title",
    "description": "Describe the problem in more detail",
    "defectClass": "Select a different type of fault"
  },
  "alt": {
    "successIllustration": "Thank you illustration"
  },
  "labels": {
    "defectLocation": "Where is the fault?",
    "defectClass": "What type of fault is it?",
    "title": "Title",
    "description": "Description",
    "files": "Attached documents",
    "masterKeyAccessAllowed": "The master key may be used to enter the apartment",
    "hasPetsInApartment": "Pets in the apartment"
  },
  "actions": {
    "back": "Back",
    "resetForm": "Clear the form",
    "sendForm": "Submit your fault report"
  },
  "defectLocations": {
    "contractTarget": "Apartment {{target}}",
    "commonArea": "Common areas"
  },
  "errors": {
    "missingUserPhoneNumber": {
      "title": "Sorry, it is not possible to create a fault report",
      "message": "To continue reporting a fault, please add your phone number to your profile."
    },
    "submitError": "An error occurred while sending your fault report. If the problem persists or if the fault is urgent, please contact customer service.",
    "serviceUnavailable": "Fault reports cannot be created at the moment. Please try again later."
  },
  "events": {
    "created": "Created",
    "completed": "Marked as completed",
    "workOrderLinked": "Work order #{{id}} attached",
    "workNoteCreated": "Work note: {{note}}",
    "workOrderCreated": "Work order #{{id}} created",
    "workOrderStarted": "Work order #{{id}} started",
    "workOrderCompleted": "Work order #{{id}} marked as completed",
    "workOrderAccepted": "Work order #{{id}} accepted"
  },
  "defectClasses": {
    "-1": "Other type of fault",
    "1": "Repair",
    "2": "HVAC",
    "3": "Minor repair",
    "4": "Electricity",
    "5": "Cleaning",
    "6": "Purchases",
    "7": "Vandalism",
    "8": "Moisture",
    "9": "Extra waste",
    "10": "Extra cleaning",
    "11": "Locks",
    "12": "Conditions",
    "13": "Fire damage",
    "14": "Building automation",
    "15": "Structures",
    "16": "Damage during winter maintenance",
    "17": "Telecom connections",
    "18": "Pests",
    "19": "Water damage"
  }
}
